<template>
  <div id="app">
    <router-view />

    <script type="application/javascript" src="./assets/js/jquery.min.js"></script>
    <script type="application/javascript" src="./assets/js/bootstrap.bundle.min.js"></script>
    <script type="application/javascript" src="/assets/js/slick.min.js"></script>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    var tableau = [
      "/assets/js/jquery.min.js",
      "/assets/js/bootstrap.bundle.min.js",
      "/assets/js/slick.min.js",
    ];

    for (let i = 0; i < tableau.length; i++) {
      const element = tableau[i];
      var imp = document.createElement('script');
      imp.src = element;
      document.head.appendChild(imp); 
    }
  }, 
  created(){
    let loaders = document.getElementsByClassName("loading-screen");
        if (loaders.length > 0) {
            loaders[0].style.zIndex = 30000000;
        }
  }
 
}
</script>

<style lang="scss">
@import './assets/css/oecca-theme.css';
@import './assets/css/portail-pages.css';
@import './assets/css/portail-accessibility.css';
@import './assets/css/admin-space.css';
@import './assets/css/bootstrap.css';
@import './assets/css/bootstrap-customer.css';
@import './assets/css/bootstrap-icons.css';
@import './assets/css/style.css';
@import './assets/css/slick.css';
@import './assets/css/select2-bootstrap-5-theme.css';
@import './assets/css/select2.min.css';
@import '~sweetalert2/dist/sweetalert2.min.css';
@import '~primevue/resources/themes/bootstrap4-light-blue/theme.css';
@import '~primevue/resources/primevue.min.css';
@import '~primeicons/primeicons.css';
@import '~vue-multiselect/dist/vue-multiselect.min.css';


.filepond--root .filepond--credits {
    display: none !important;
}
</style>
